import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const PortalsInUseContainer = styled.div`
  display: flex;
  justify-content: end;
`
